import {graphql, useStaticQuery} from 'gatsby'

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteName
          title
          description
          keywords
          image
          twitterUsername
          siteUrl
          currentYear
          externalLinkInfo {
            TITLE
            BODY
            LINK_CLASS_NAME
            OVERLAY_CLASS_NAME
          }
        }
      }
    }
  `)

  return data.site.siteMetadata
}
